import { RequestStatus } from "../../../request";
import { ROASReport } from "./reducer";

export const FetchROASReport = ({
  from,
  until,
  breakdowns,
  periodicity,
  filters,
  userFrom,
  userUntil,
  coinsFilters,
}: {
  from: Date;
  until: Date;
  breakdowns?: string[];
  periodicity?: "daily" | "weekly" | "monthly" | "yearly";
  filters?: any;
  userFrom?: string;
  userUntil?: string;
  coinsFilters?: {
    changeType:
      | "usage"
      | "challenge_open"
      | "challenge_app_event"
      | "challenge_app_revenue_event";
  };
}) => {
  return {
    type: "roas-request-report",
    from,
    until,
    filters,
    breakdowns,
    periodicity,
    userFrom,
    userUntil,
    coinsFilters,
  };
};

export const UpdateROASReportRequestState = (requestState: RequestStatus) => {
  return {
    type: "roas-update-request-state",
    requestState: requestState,
  };
};

export const UpdateROASReport = (report: ROASReport) => {
  return {
    type: "roas-update-report",
    report: report,
  };
};

export const ResetROASData = () => {
  return {
    type: "roas-reset-data",
  };
};
